export default "__VITE_ASSET__CSwH3XlR__"